<div id="loading">
    <div id="loading-center">
        <img src="{{imagesUrl}}logo-black.png" alt="loader-digital">
    </div>
</div>
<!-- Header Component Start-->
<app-header [logoImg]="logoWhite" [logoClass]="logoClass" [logoWhite]="navLogo" className="main-header"
    [navItemList]="navItems"></app-header>
<!-- Header Component End-->
<!-- START sofbox4 REVOLUTION SLIDER 6.1.3 -->
<app-slider [header1]="headerText1" [header2]="headerText2" [text1]="text1" [text2]="text2" [videoUrl]="videoUrl"
    [imageUrl]="imageUrl">
</app-slider>
<!--End sofbox2 REVOLUTION SLIDER -->
<!-- Main Content -->
<div class="main-content" id="iq-about">
    <app-services></app-services>
    <app-service></app-service>
    <!-- <app-about></app-about> -->
    <!-- <app-features></app-features> -->
    <app-testimonial></app-testimonial>
    <!-- <app-pricing></app-pricing> -->
    <!-- <app-blog></app-blog> -->

    <app-v-two-contact-map [sectionProp]="sectionProp" [contactDetail]="contactDetail">
        <div titleSection>
            <app-v-two-section-title [titleSectionProp]="titleSectionProp"></app-v-two-section-title>
        </div>
        <ul socailLink class="share-social list-inline p-0">
            <li class="list-inline-item"><a target="_blank"
                    href="https://www.facebook.com/Digital-Lobby-1233191616815475/"><i class="fa fa-facebook-f"></i></a>
            </li>
            <!-- <li class="list-inline-item"><a href="#"><i class="fa fa-github"></i></a></li> -->
            <li class="list-inline-item"><a target="_blank" href="https://www.instagram.com/digitallobby1"><i
                        class="fa fa-instagram"></i></a></li>
            <li class="list-inline-item"><a href="https://wa.me/message/BJ3GPZ4C5E73D1"><i
                        class="fa fa-whatsapp"></i></a></li>
            <li class="list-inline-item"><a href="mailto:sales@dlobby.co.il"><i class="fa fa-envelope"></i></a></li>
        </ul>
        <form contactForm [formGroup]="contactForm" (ngSubmit)="sendMessage()" style="display: none;">
            <div class="row">
                <div class="col-lg-4">
                    <input type="text" class="form-control" id="inputName" placeholder="שם מלא"
                        formControlName="fullName">
                </div>
                <div class="col-lg-4">
                    <input type="Email" class="" id="inputEmail" placeholder="כתובת אימייל" formControlName="mail">
                </div>
                <div class="col-lg-4">
                    <input type="number" class="" id="inputPhone" placeholder="מספר טלפון" formControlName="phone">
                </div>
                <div class="col-lg-12">
                    <input type="text" class="form-control" id="inputSubject" placeholder="נושא"
                        formControlName="subject">
                </div>
                <div class="col-lg-12">
                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="7" placeholder="ההודעה"
                        formControlName="message"></textarea>
                </div>
                <div class="col-lg-12">
                    <!-- <a class="button blue-btn" href="#">שלח הודעה</a> -->
                    <button class="button blue-btn">שלח הודעה</button>
                </div>
            </div>
        </form>
    </app-v-two-contact-map>
</div>
<app-v-two-footer-style2 [footerLogo]="footerLogo" [footerText]="footerText" [footerTitle]="footerTitle"
    [footerDescription]="footerDescription">
    <ul menu>
        <li><a class="text-white" (click)="jumpTo('#iq-service'); false" href="">השירותים שלנו</a></li>
        <li><a class="text-white" (click)="jumpTo('#whyUs'); false" href="">למה דיגיטל לובי</a></li>
        <li><a class="text-white" (click)="jumpTo('#testimonials'); false" href="">תכירו את הלקוחות שלנו</a></li>
        <li><a class="text-white" (click)="jumpTo('#iq-contact'); false" href="">צרו קשר</a></li>
        <!-- <li><a class="text-white" href="javascript:void(0)">Blog</a></li> -->
    </ul>
    <ul about_us>
        <!-- <li><a class="text-white" href="javascript:void(0)">מסכים דיגיטליים</a></li>
        <li><a class="text-white" href="javascript:void(0)">מסכים לעסקים</a></li>
        <li><a class="text-white" href="javascript:void(0)">שירותים לבית עסק</a></li>
        <li><a class="text-white" href="javascript:void(0)">מסך ללובי</a></li> -->
        <li><a class="text-white" [routerLink]="'/offices'">מסך למשרדים</a></li>
        <li><a class="text-white" [routerLink]="'/business'">שירותים לעסקים ובתי עסק</a></li>
        <li><a class="text-white" [routerLink]="'/buildings'">מסך ללובי</a></li>
        <li><a class="text-white" [routerLink]="'/buildings'">מסך לבניינים</a></li>
        <li><a class="text-white" [routerLink]="'/business'">מסכים דיגיטליים</a></li>

    </ul>

</app-v-two-footer-style2>

<app-fly-icon [message]="'היי הגעתי דרך האתר ואני מעוניין בפרטים נוספים'"></app-fly-icon>